import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiGithubFill } from '@remixicon/react';
import { rootRouteRef } from './routes';

export const githubOnboardingPage = PageBlueprint.make({
  params: {
    title: 'GitHub Onboarding',
    icon: <RiGithubFill />,
    path: '/onboarding/github',
    routeRef: rootRouteRef,
    loader: () => import('./app').then(m => <m.GithubOnboardingRoot />),
  },
});

export const headerActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () =>
        import('./components/header-actions').then(m => <m.HeaderActions />),
    }),
});

export const githubOnboardingPlugin = createFrontendPlugin({
  pluginId: 'github-onboarding',
  extensions: [githubOnboardingPage, headerActions],
  routes: {
    root: rootRouteRef,
  },
});
